import React from 'react'
import Slider from 'react-slick'
import Image from '../atoms/Image'
import Headline from '../atoms/Headline'
import Link from '../atoms/Link'
import SbEditable from 'storyblok-react'

import { useTranslation } from 'react-i18next'

const ReferenceSliderBlock = ({ block }) => {
  const { t } = useTranslation()

  function NextArrow(props) {
    const { className, onClick } = props
    return (
      <span className={className} onClick={onClick}>
        <i className="fal fa-chevron-right"></i>
      </span>
    )
  }

  function PrevArrow(props) {
    const { className, onClick } = props
    return (
      <span className={className} onClick={onClick}>
        <i className="fal fa-chevron-left"></i>
      </span>
    )
  }

  const settings = {
    arrows: true,
    dots: true,
    infinite: false,
    autoplay: block.autoplay === true ? true : false,
    autoplaySpeed: 5000,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow className="slick-prev" />,
    nextArrow: <NextArrow className="slick-next" />,
  }

  return (
    <SbEditable content={block}>
      <section className="reference-slider-block">
        <div className="reference-slider-block-container">
          <Slider {...settings} className="reference-slider-block-slider">
            {block.reference_slider_block_content?.length > 0 &&
              block.reference_slider_block_content.map((item, index) => (
                <div className="reference-slider-block-slider-item">
                  <div className="reference-slider-block-slider-item-content-image">
                    <Image
                      image={item.image}
                      alt={item.alt}
                      title={item.alt}
                      imageWidth="1280"
                      imageHeight="500"
                    />
                  </div>
                  <div className="reference-slider-block-slider-item-content">
                    <div className="reference-slider-block-slider-item-content-left">
                      <Headline
                        kicker={t('generic.references')}
                        headline={item.headline}
                      />
                    </div>
                    <div className="reference-slider-block-slider-item-content-right">
                      <p className="reference-slider-block-slider-item-content-text">
                        {item.text}
                      </p>
                      <Link
                        className="btn btn-primary"
                        link={item.link}
                        target={item.tab_link ? '_blank' : '_self'}
                      >
                        {item.link_text}
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
          </Slider>
        </div>
      </section>
    </SbEditable>
  )
}

export default ReferenceSliderBlock
